import { SerialChartWidgetDataService } from '@/modules/ta/legacy/widget/services/data/SerialChartWidgetDataService';

export class BarChartDataService extends SerialChartWidgetDataService {}
